var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.instructions)?_c('div',{staticClass:"instructions"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.instructions)}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }